module.exports = {"330106002":"北山街道","330106004":"西溪街道","330106005":"翠苑街道","330106007":"古荡街道","330106008":"西湖街道","330106009":"留下街道","330106010":"转塘街道","330106011":"蒋村街道","330106012":"灵隐街道","330106013":"文新街道","330106109":"三墩镇","330106110":"双浦镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330106.json
// module id = 945
// module chunks = 0